import PropTypes from 'prop-types';

import './styles.css';
import '../Panels/styles/panelStyles.css';

const Card = ({ children, className, ...rest }) => (
  <div className={`panel flex flex-col justify-start ${className}`} {...rest}>
    {children}
  </div>
);

Card.defaultProps = {
  className: '',
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Card;
